import { onMounted } from 'vue'

import MENU from '@/constantes/controle_acesso/MENU'
import appStore from '@/stores'

function aplicarMenu(menu) {
  appStore.setNavegacao(menu)
}

export function useMenu(menuConfig) {
  onMounted(() => {
    if (typeof menuConfig === 'number') {
      const menu = MENU.valores.find((m) => m.id === menuConfig)
      if (!menu) {
        appStore.resetNavegacao()
        return
      }
      aplicarMenu(menu)
      return
    }

    if (menuConfig && typeof menuConfig === 'object') {
      aplicarMenu(menuConfig)
      return
    }

    appStore.resetNavegacao()
  })
}
